import SegmentClassSPSlice from "../slices/SegmentClassSPSlice";
import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { SegmentClassSPModel } from "../../models/SegmentClassSPModel";
import SegmentClassSPService from "../../services/SegmentClassSPService";

export const SegmentClassSPActions = SegmentClassSPSlice.actions;

export const fetchParticularSegmentClassSP = (segmentLobId: number, customerTypeId: number): ThunkAction<void, RootState, unknown, AnyAction> => {
    return async (dispatch, getState) => {
        const response: SegmentClassSPModel = await SegmentClassSPService.getParticularSegmentClassSP(segmentLobId, customerTypeId);
        dispatch(SegmentClassSPActions.setParticularSegmentClassSP(response));
    }
}